<template>
  <div class="h-dialogContainer">
    <div class="col-lg-12">
    <!--<div class='h-nomargin h-track-flexContent h-track-flexColumn h100 h100vh-180'>-->
      <!--<ejs-textbox :placeholder='搜索网元' v-model='keywords' :change='filterLocalTreeData'>-->
      <div class="h-subscriber-input-qry-width">
        <ejs-textbox :placeholder='$t("SubscriberIms.search")' v-model='keywords' v-if="searchFlag" maxLength="50" @keydown.enter.native='filterLocalTreeData'>
          <span class='icon hero-icon hero-icon-search'></span>
        </ejs-textbox>
      </div>

      <slot name="organizationalIcon_solt"></slot>

      <div class='h-scroll h100vh-180 h-subscriber-vpntree-width'>
        <ejs-treeview
          ref="tree1"
          id="tree1"
          :fields="fields"
          :allowEditing="false"
          :nodeSelected="nodeSelected"
          :nodeClicked="nodeClicked"
          :allowDragAndDrop="true"
          :nodeDragging="nodeDraggingMethod"
          :nodeDragStop="nodeDragStopMethod"
        ></ejs-treeview>
      </div>
    </div>
  </div>
</template>


<script>
  import {EventBus} from '../../../plugins/eventBus';
  import commonJS from './common';

  class TreeDatas {
  constructor(dataSource) {
    this.dataSource = dataSource || [{ children: [] }];
    this.id = 'id_show';
    this.text = 'name';
    this.child = 'children';
  }
}

export default {
  mixins: [commonJS],
  data() {
    return {
      searchFlag: true,
      cycleCount: 0,
      fields: {
        tooltip: 'name',
      },
      fieldsDataBak: [],
      fieldsDataFilter: [],
      nodeSelect: undefined,
      vo: {

      },
      info: {
        msgid: '',
        neid: '',
        operation: ''
      },
      operationList: {
        qryAll: 'getVpnTreeWithNeid',
        qryByid: 'getVpnTreeWithVpnid'
      },
      keywords: '',
      staDoFieldsList: [],
      staDoFields: [],
      neData: [],
      neArr: [2142],
      qryNeids: [],
      timer1: null,
      initData: [],
      noVpnRoleDataTemp: [],
      noVpnRoleDataAll: [],
      disableNode:[],
      allNode: [],
      neinfoMap: new Map(),
      fuzzyFlag: false,
      logParamInfo: {
        // module: 'subscriber.organization',
        module: 'res.subscriber#res.subscriber_mcs#subscriber.organization',
        execFunName: ['subscriber.addChildNode', 'subscriber.addSiblingNode', 'subscriber.modifyVpn', 'subscriber.delete'], // 添加子节点 添加平级节点 修改节点  删除节点
      },
    };
  },
  props: [
    'nodeSelectProp',
    'neid',
    'vpndata',
    'disableNodes'
  ],
  methods: {
    setfFuzzyFlag(flag) {
      this.fuzzyFlag = flag;
    },
    clear() {
      this.searchFlag = false;
      this.$nextTick(() => {
        this.searchFlag = true;
      });
    },
    getNeinfoMap() {
      return this.neinfoMap;
    },
      initAllNode() {
      this.allNode = this.$refs.tree1.getTreeData();
    },
    async findEquiName() {
      await this.$axios.get('/lte/ems/deployed/queryDeployedInfoAll').then((response) => {
        const result = response.data.resultVal;
        debugger;
        // 获取设备名称
        this.neData.forEach((item) => {
          result.forEach((value) => {
            if(item.id === value.id){
              item.equipmentName = value.runEnvironment;
              this.neinfoMap.set(item.id, value.runEnvironment);
            }
          });
        });
      });
    },
    async filterHytalkPro(_nodeArray) {
      const $this = this;
      await this.$axios.get('/lte/ems/topo/device/devPage?pageNo=1&pageSize=2000').then((response) => {
        const { result } = response.data.resultVal;
        _nodeArray.forEach((item) => {
          result.forEach((value) => {
            value.equipmentIPList.forEach((eitem) => {
              if (eitem.id === item.equipmentIPId) {
                if(value.typeCode === 10003) {
                  const { id, name, equipmentIPId, typeCode } = item;
                  const _dataItem = {
                    text: `${id}-${name}`,
                    id,
                    neType: typeCode,
                    equipmentIPId
                  };
                  $this.neData.push(_dataItem);
                  $this.qryNeids.push(id);
                  this.$emit('qryNeids', $this.qryNeids);
                }
              }
            });
          });
        });
      });
    },
    async getOrganizationalTree() {
      // console.log('neid', this.neid);
      // if (this.neid !== null && this.neid !== '') {
      //   return;
      // }
      // 获取有权限的phss网元
      const $this = this;
      $this.neData = [];
      $this.qryNeids = [];
      $this.$loading.showLoadding(this.$t('SubscriberIms.loadingvpn'),this.$t('SubscriberIms.waitTip'));
      this.$axios.post('/lte/ems/auth/findElementListByAuth', this.neArr).then((response) => {
        if (response.status !== 200) {
          // $this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
          $this.$loading.hideLoadding();
        } else {
          const _nodeArray = response.data;
          if(_nodeArray.length === 0){
            $this.$loading.hideLoadding();;
            return;
          }
          //let nodeStatus;
          let clusterArray = [];
          _nodeArray.forEach((_item) => {
/*            $this.axios.get(`/lte/ems/config/mml/queryNodeLinkStatus/${_item.id}`).then(res => {
              console.log('nodestatus',_item.id,res);
              nodeStatus = res.data ? res.data.resultVal : 0;
            });*/
            const { id, name, equipmentIPId, typeCode } = _item;
            const _dataItem = {
              text: `${id}-${name}`,
              id,
              neType: typeCode,
              equipmentIPId,
            };
            if(clusterArray.indexOf(_item.clusterId) === -1)
            {
              console.log('clusterId',_item.clusterId);
              clusterArray.push(_item.clusterId)
              $this.neData.push(_dataItem);
              $this.qryNeids.push(id);
              this.$emit('qryNeids', $this.qryNeids);
            }
          });
          console.log('$this.neData', $this.neData);
          if ($this.qryNeids.length !== 0) {
            $this.findEquiName();// 查询设备名称
            console.log('qryNeids',$this.qryNeids);
            const params = {};
            const vo = { 0: { vo:{neid: $this.qryNeids,productType:1,enterpriseDomain:"mcs.com",flag:0,vpnId:""},info:{msgid:46103,neid:$this.qryNeids,productType:1,enterpriseDomain:"mcs.com"},page:{pageNo:1,pageSize:20000} } };
            params.vo = vo;
            $this.info.operation = $this.operationList.qryAll;
            $this.info.msgid = 46103;
            $this.info.neid = $this.qryNeids;
            params.info = $this.info;
            // 获取vpn树
            this.$axios.post('/lte/ems/subscriber/mcs/requestCommonMicro', params).then((res) => {
              // TODO:增加权限过滤
              if (res.status !== 200) {
                // $this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
                EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
                $this.$loading.hideLoadding();
              } else {
                // res.data.resultVal = '[]';
                $this.initData = JSON.parse(res.data.resultVal);
                if ($this.initData === null || ($this.initData && $this.initData.length === 0)) {
                  $this.$loading.hideLoadding();
                  return;
                }
                $this.staDoFieldsList = $this.initData;
                this.$axios.post('/lte/ems/auth/findVpnListByAuth').then((result) => {
                  $this.initData.forEach((item, index) => {
                    console.log('item, index', item, index, $this.neinfoMap, $this.neinfoMap.get(parseInt(item.systemId, 10)));
                    // item.name = `${$this.$t('SubscriberIms.organization')}[${$this.neData[index].equipmentName}]`;
                    item.name = `${$this.$t('SubscriberIms.organization')}[${$this.neinfoMap.get(parseInt(item.systemId, 10))}]`;
                  });
                  console.log(result);
                  // result.data[0] = { vpnId: '7_0' };
                  // result.data = [{ vpnId: '9_7_1' }, { vpnId: '9_7_2' }, { vpnId: '9_7_3' }];
                  $this.$loading.hideLoadding();
                  console.log('iniData before', $this.initData);
                  //$this.fields = new TreeDatas($this.initData);//渲染组织架构树
                  // 有权限的---把无权限的都过滤掉
                  // 使用树时，若查询的权限为空，则取消下面一行代码的注释
                  // for (const index in $this.qryNeids) {
                  //   result.data.push($this.qryNeids[index]+'_7_0');
                  // }
                  console.log('result', result.data);
                  if (result.data && result.data.length > 0) {
                    const roleV = result.data.filter((item) => item.vpnId === '7_0'); // Eadmin角色所有权限
                    const neids = [];
                    if (roleV && roleV.length > 0) {
                      result.data = [];
                      for (const index in $this.qryNeids) {
                        result.data.push({vpnId: `${$this.qryNeids[index]}_7_0`});
                      }
                    } else {
                      // 组织架构权限中没有权限过滤（按网元id）
                      for (const neidVal in $this.qryNeids) {
                        console.log('neid=', $this.qryNeids[neidVal]);
                        const tmp = result.data.filter((item) => item.vpnId.split('_')[0].toString() === $this.qryNeids[neidVal].toString());
                        if (tmp && tmp.length > 0) {
                          continue;
                        }
                        neids.push($this.qryNeids[neidVal]);
                      }
                    }
                    $this.setNoRoleArrayWithNe($this.initData, neids);
                    $this.setRole($this.initData, result.data);
                    console.log("noVpnrole", this.noVpnRoleDataAll);
                    for (let i = 0; i < this.noVpnRoleDataAll.length; i++) {
                      this.removeNode(this.initData, this.noVpnRoleDataAll[i])
                    }
                    $this.fields = new TreeDatas([]);
                    $this.fields = new TreeDatas(this.initData);//渲染组织架构树
                    this.timer1 = setTimeout(() => {
                      console.log('initdata after remove', this.initData);
                      console.log('disableNodes', this.disableNode);
                      $this.$refs.tree1.disableNodes(this.disableNode);
                    }, 100);
                  } else {
                    // 循环res.data，找到这个网元的所有节点，设置成无权限
                    $this.setNoRoleArrayWithNe($this.initData, $this.qryNeids);
                    $this.$refs.tree1.removeNodes(this.noVpnRoleDataAll);
                  }
                  $this.initAllNode();
                });
              }
            });
          } else {
            $this.$loading.hideLoadding();
          }
        }
      });
    },
    removeNode(arrs, idshow) {
      var i = 0;
      while (arrs[i]) {
        if (arrs[i].id_show === idshow) {
          arrs.splice(i, 1);
          return;
        }
        if (arrs[i].children !== null) {
          this.removeNode(arrs[i].children, idshow);
        }
        i++;
      }
    },
    getNodeName(idshow){
      return this.getName(this.initData, this.qryNeids,idshow);
    },
    getName(dataSrc, neids,idshow) {
      let nodename = null;
      for (let i = 0; i < neids.length; i++) {
        const data = dataSrc.filter((item) => parseInt(item.id_show.split('_')[0], 0) === neids[i]);
        nodename = this.getNodeNameIter(data,idshow);
        if(nodename !== undefined){
          return nodename;
        }
      }
    },
    getNodeNameIter(data,idshow)
    {
      let nodetext =null;
      for(const j in data){
        if(data[j].id_show === idshow){
          return data[j].text;
        }
      }
      const dataHasChildrenTemp = data.filter((item) => item.children !== null);
      if (dataHasChildrenTemp && dataHasChildrenTemp.length > 0) {
        for (const i in dataHasChildrenTemp) {
          nodetext = this.getNodeNameIter(dataHasChildrenTemp[i].children,idshow);
          if(nodetext !== undefined)
          {
            return nodetext;
          }
        }
      }
    },
    setRole(dataSrc, roleDataSrc) {
      for (const j in dataSrc) {
        this.filter(dataSrc[j], roleDataSrc);
      }
    },
    filter(node, roleDataSrc, isparenthasrole) {
      let rmflag = true;
      let hasrole = false;
      let childrmflag = false;
      const roleData = roleDataSrc.filter((item) => item.vpnId === node.id_show);//获得有权限的节点
      if (roleData && roleData.length > 0) {//有权限
        rmflag = false;
        hasrole = true;
      }
      else {
        rmflag = true;
        hasrole = isparenthasrole;
      }
      if ((node.children)) {
        const dataSrcTempChild = node.children;
        for (let k = 0; k < dataSrcTempChild.length; k++) {
          childrmflag = this.filter(dataSrcTempChild[k], roleDataSrc, hasrole);
          if (childrmflag && !hasrole) {
            this.noVpnRoleDataAll.push(dataSrcTempChild[k].id_show);
          }
          else if (!childrmflag && !hasrole) {
            rmflag = false;
            this.disableNode.push(node.id_show);
          }
          else {
            rmflag = false;
          }
        }
      }
      return rmflag;
    },
    setNoRoleArray(dataNoRole) {
      for (let i = 0; i < dataNoRole.length; i++) {
        this.noVpnRoleDataAll.push(dataNoRole[i].id_show);
      }
      console.log(this.noVpnRoleDataAll);
    },
    setNoRoleArrayWithNe(dataSrc, neids) {
      for (let i = 0; i < neids.length; i++) {
        console.log(neids[i]);
        const data = dataSrc.filter((item) => parseInt(item.id_show.split('_')[0], 0) === neids[i]);
        this.nodeIteration(data);
      }
    },
    // 寻找所有节点
    nodeIteration(data) {
      const dataHasChildrenTemp = data.filter((item) => item.children !== null);
      const dataNoChildrenTemp = data.filter((item) => item.children === null);
      this.setNoRoleArray(dataNoChildrenTemp);
      if (dataHasChildrenTemp && dataHasChildrenTemp.length > 0) {
        for (const i in dataHasChildrenTemp) {
          this.noVpnRoleDataAll.push(dataHasChildrenTemp[i].id_show);
          this.nodeIteration(dataHasChildrenTemp[i].children);
        }
      }
    },
    // 判断同级节点的权限
    checkSiblingData(dataSrc, roleVpnArray) {
      const dataNoRoleTemp = [];
      const dataNoRoleTempMap = new Map();
      if (dataSrc.children) {
        const dataSrcTempChild = dataSrc.children;
        for (let j = 0; j < dataSrcTempChild.length; j++) {
          dataNoRoleTempMap.set(dataSrcTempChild[j].id_show, dataSrcTempChild[j]);
          for (let i = 0; i < roleVpnArray.length; i++) {
            if (dataSrcTempChild[j].id_show === roleVpnArray[i].vpnId) {
              dataNoRoleTempMap.delete(dataSrcTempChild[j].id_show);
            }
          }
        }
        if (dataNoRoleTempMap && dataNoRoleTempMap.size > 0) {
          dataNoRoleTempMap.forEach((item) => {
            dataNoRoleTemp.push(item);
          });
        }
        console.log(dataNoRoleTemp);
        if (dataNoRoleTemp && dataNoRoleTemp.length > 0) {
          const dateTemp = {
            children: dataNoRoleTemp
          };
          while (this.cycleCount <= roleVpnArray.length - 1) {
            this.cycleCount++;
            if (this.cycleCount === roleVpnArray.length) {
              console.log('dataNoRoleTemp=', dataNoRoleTemp);
              this.noVpnRoleDataTemp = dataNoRoleTemp;
              this.setNoRoleArray(dataNoRoleTemp);
            } else {
              this.checkSiblingData(dateTemp, roleVpnArray);
            }
          }
        }
      }
      // const dataNoRoleTemp = dataSrc.children && dataSrc.children.filter((item) => item.id_show !== roleVpnArray[this.cycleCount].vpnId);
    },
    // 根据传入的角色给现有树迭代--找到没有权限的节点
    vpnNoRoleIterationTest(dataSrc, roleVpnArray) {
      let vpnNoRoleData = [];
      this.checkSiblingData(dataSrc, roleVpnArray);
      console.log('this.noVpnRoleData=', this.noVpnRoleDataTemp.length, this.cycleCount);
      vpnNoRoleData = vpnNoRoleData.concat(this.noVpnRoleDataTemp);
      this.cycleCount = 0;
      this.noVpnRoleDataTemp = [];
      console.log('vpnNoRoleData=', vpnNoRoleData.length, this.cycleCount);
      if (vpnNoRoleData && vpnNoRoleData.length > 0) { // 没有权限的节点，继续往下遍历
        for (let i = 0; i < vpnNoRoleData.length; i++) {
          if (vpnNoRoleData[i].children !== null) {
            console.log('有子节点');
            this.vpnNoRoleIterationTest(vpnNoRoleData[i], roleVpnArray);
          }
        }
      }
    },
    // 根据传入的角色给现有树迭代--找到没有权限的节点
    vpnNoRoleIteration(dataSrc, roleVpn, vpnNoRoleData) {
      const dataNoRole = dataSrc.children.filter((item) => item.id_show !== roleVpn);
      const dataHasRole = dataSrc.children.filter((item) => item.id_show === roleVpn);
      if (dataNoRole) { // 没有权限的节点，继续往下遍历
        for (let i = 0; i < dataNoRole.length; i++) {
          // vpnNoRoleData.push(dataNoRole[i].id_show);
          if (dataNoRole[i].children) {
            this.vpnNoRoleIteration(dataNoRole[i], roleVpn, vpnNoRoleData);
          }
        }
      }
      if (dataHasRole) {
        for (let j = 0; j < dataHasRole.length; j++) {
          if (vpnNoRoleData.get(dataHasRole[j].id_show)) {
            vpnNoRoleData.delete(dataHasRole[j].id_show);
          }
        }
      }
    },
    getOrganizationalTreeWithNeid() {
      const $this = this;
      const vpn = $this.vpndata.filter((item) => item.id_show === `${this.neid}_7_0`);
      $this.fields = new TreeDatas(vpn);
      this.disableNode = this.disableNodes;
      this.timer1 = setTimeout(() => {
        $this.$refs.tree1.disableNodes($this.disableNodes);
      }, 100);
    },
    // 后续可以考虑树是否在前台生成
    dotransfer2TreeData(treeData, parentid = []) {
      return treeData
        .filter(item => parentid.indexOf(item.parentId) > -1)
        .map(item => {
          const { id, name, parentId } = item;
          return {
            expanded: false,
            // isChecked: this.doChecked[item.id],
            id,
            name,
            parentId,
            children: this.dotransfer2TreeData(treeData, [item.id])
          };
        });
    },
    nodeClicked(args) {
      if (args.node.getAttribute('aria-disabled')) {
        // this.$layer.alert({ msg: '该节点没有操作权限' });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.noOperatRole') });
      }
    },
    nodeSelected(args) {
      this.nodeSelect = this.$refs.tree1.getNode(args.node);
      this.nodeSelect.level = args.node.classList[1].split('-')[2];
      const neNode = this.neData.filter((item) => item.id == this.nodeSelect.id.split('_')[0]);
      if (neNode && neNode.length > 0) {
        this.nodeSelect.neName = neNode[0].text;
        this.nodeSelect.neNode = neNode[0];
      }
      this.nodeSelectProp && this.nodeSelectProp(this.nodeSelect);
    },
    getNode() {
      return this.nodeSelect;
    },
    // 返回选中的节点
    getNodeSelected() {
      return this.nodeSelect;
    },
    async getNodeFun(node, type) {
      const nodeVpn = {
        productType:1,
        enterpriseDomain:"mcs.com",
        vpnId: this.nodeSelect.id.split('_')[2],
        vpnName: node.get('vpnName'),
        orgCode: node.get('orgCode'),
        //vpnLevel:"",
        groupCount: node.get('groupCount')===""?4294967295:node.get('groupCount'),
        userCount: node.get('userCount')===""?4294967295:node.get('userCount'),
        audioMax: node.get('audioMax')===""?4294967295:node.get('audioMax'),
        videoMax: node.get('videoMax')===""?4294967295:node.get('videoMax'),
        vpnClass1: 0,
        vpnClass2: 0,
        vpnClass3: 0,
        vpnClass4: 0,
        vpnClass5: 0,
        vpnClass6: 0,
        vpnLevel: ''
      };
      const neid = parseInt(this.nodeSelect.id.split('_')[0], 0);
      const id = parseInt(this.nodeSelect.id.split('_')[2], 0);
      let pid = 0;
      if (id !== 0) {
        pid = parseInt(this.nodeSelect.parentID.split('_')[2], 0);
      }
      let pnode = null;
      if ((type === 0 && id === 0) || (type === 1 && pid === 0)) {
        nodeVpn.vpnLevel = 1;
        return nodeVpn;
      }
      if (type === 1) {
        pnode = await this.queryById(pid, neid);
      } else {
        pnode = await this.queryById(id, neid);
      }
      console.log("pnode",pnode);
      if (type === 0 && pnode.vpnClass6 !== "0") {
        return pnode;
      }

      nodeVpn.vpnClass1 = pnode.vpnClass1 !== "0" ? pnode.vpnClass1 : 0;
      nodeVpn.vpnClass2 = pnode.vpnClass2 !== "0" ? pnode.vpnClass2 : 0;
      nodeVpn.vpnClass3 = pnode.vpnClass3 !== "0" ? pnode.vpnClass3 : 0;
      nodeVpn.vpnClass4 = pnode.vpnClass4 !== "0" ? pnode.vpnClass4 : 0;
      nodeVpn.vpnClass5 = pnode.vpnClass5 !== "0" ? pnode.vpnClass5 : 0;
      nodeVpn.vpnClass6 = pnode.vpnClass6 !== "0" ? pnode.vpnClass6 : 0;

      if (nodeVpn.vpnClass2 == 0) {
        nodeVpn.vpnLevel = 2;
      } else if (nodeVpn.vpnClass3 == 0) {
        nodeVpn.vpnLevel = 3;
      } else if (nodeVpn.vpnClass4 == 0) {
        nodeVpn.vpnLevel = 4;
      } else if (nodeVpn.vpnClass5 == 0) {
        nodeVpn.vpnLevel = 5;
      } else if (nodeVpn.vpnClass6 == 0) {
        nodeVpn.vpnLevel = 6;
      }
      return nodeVpn;
    },
    async queryById(vpnid, neid) {
      let pnode = null;
      const queryByIdParam = {};
      queryByIdParam.vpnId = vpnid;
      queryByIdParam.flag = 0;
      queryByIdParam.productType = 1;
      queryByIdParam.enterpriseDomain = "mcs.com";
      await this.$axios
        .post('/lte/ems/subscriber/mcs/requestCommonMicro', { vo: queryByIdParam,
          info: { msgid: 46103, neid },
          page: { page: 1, count: 1 }
        }).then(response => {
          pnode = response.data.resultVal.result[0];
        });
      return pnode;
    },
    /**
     * 新增
     * params：界面获取的行对象(vpnname,orgcode)
     * type:标识新增子节点或平级节点
     * 新增前根据行对象的父id先查询各级vpnClass号  type = 0 子节点  type = 1 平级节点
     */
    async lteAddVpnMethod(params, type) {
      if (!this.nodeSelect) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.chooseNodeTip') });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.chooseNodeTip') });
        return;
      }
      const nodeVpn = await this.getNodeFun(params, type);
      if (type === 0 && nodeVpn.vpnClass6 !== 0) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.nodesCountTip') });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.nodesCountTip') });
        return;
      }
      if (nodeVpn) {
        const logParam = {
          // module: this.$t('SubscriberIms.organization'), // 组织架构
          // execFunName: type === 0 ? this.$t('SubscriberIms.addChildNode') : this.$t('SubscriberIms.addSiblingNode'), // 0添加子节点 1添加平级节点
          module: this.logParamInfo.module, // 组织架构
          execFunName: type === 0 ? this.logParamInfo.execFunName[0] : this.logParamInfo.execFunName[1], // 0添加子节点 1添加平级节点
          exectype: 1,
          execData: [nodeVpn],
        };
        await this.$axios
          .post('/lte/ems/subscriber/mcs/requestCommonMicro', { vo: nodeVpn,
            info: {
              msgid: 46100,
              neid: this.nodeSelect.id.split('_')[0]
            },
            log: logParam
          })
          .then(response => {
            /*console.log(response.data);
            if (response.status !== 200) {
              // this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
              EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
              return;
            }
            if (response.data.resultVal && response.data.resultVal.length > 0) {
              // this.$layer.alert({ msg: response.data.resultVal[0].display });
              if (response.data.resultVal[0].code.split('.')[2] === '0') {
                EventBus.$emit('toast', { type: 'success', content: response.data.resultVal[0].display });
                this.getOrganizationalTree();
              } else {
                EventBus.$emit('toast', { type: 'warning', content: response.data.resultVal[0].display });
              }
            } else {
              // this.$layer.alert({ msg: this.$t('resultReturnFailedTip') });
              EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.resultReturnFailedTip') });
            }*/
            this.commonResp(response);
            this.getOrganizationalTree();

          });
      }
    },
    /**
     * 修改
     * node：界面获取的行对象
     * 修改前根据行对象的父id先查询各级vpnClass号
     */
    async lteModVpnMethod(params) {
      const vpnid = this.nodeSelect.id.split('_')[2];
      const neid = this.nodeSelect.id.split('_')[0];
      let vpnNode = await this.queryById(vpnid, neid);
      vpnNode.vpnName = params.get('vpnName');
      vpnNode.orgCode = params.get('orgCode');
      vpnNode.groupCount = params.get('groupCount')===""?4294967295:params.get('groupCount');
      vpnNode.userCount = params.get('userCount')===""?4294967295:params.get('userCount');
      vpnNode.audioMax = params.get('audioMax')===""?4294967295:params.get('audioMax');
      vpnNode.videoMax = params.get('videoMax')===""?4294967295:params.get('videoMax');
      vpnNode.productType = 1;
      vpnNode.enterpriseDomain = "mcs.com";

      //vpnNode = this.validateVPN(vpnNode);
      const logParam = {
        module: this.logParamInfo.module, // 组织架构
        execFunName: this.logParamInfo.execFunName[2], // 修改节点
        exectype: 2,
        execData: [vpnNode],
      };
      await this.$axios
        .post('/lte/ems/subscriber/mcs/requestCommonMicro', { vo: vpnNode,
          info: {
            msgid: 46101,
            neid: this.nodeSelect.id.split('_')[0]
          },
          log: logParam
        })
        .then(response => {
          /*console.log(response.data);
          if (response.status !== 200) {
            // this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
            return;
          }
          if (response.data.resultVal && response.data.resultVal.length > 0) {
            // this.$layer.alert({ msg: response.data.resultVal[0].display });
            if (response.data.resultVal[0].code.split('.')[2] === '0') {
              this.getOrganizationalTree();
              EventBus.$emit('toast', { type: 'success', content: response.data.resultVal[0].display });
            } else {
              EventBus.$emit('toast', { type: 'warning', content: response.data.resultVal[0].display });
            }
          } else {
            // this.$layer.alert({ msg: this.$t('resultReturnFailedTip') });
            EventBus.$emit('toast', { type: 'warning', content: this.$t('resultReturnFailedTip') });
          }*/
           this.commonResp(response);
            this.getOrganizationalTree();
        });
    },
    /**
     * 删除
     * node：界面获取的行对象
     * 删除前根据行对象的父id先查询各级vpnClass号
     */
    async lteDelVpnMethod() {
      const node = this.nodeSelect;

      if (!node) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.chooseNodeTip') });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.chooseNodeTip') });
        return;
      }
      const id = parseInt(node.id.split('_')[2], 0);
      if (id === 0) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.notDelRootNode') });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.notDelRootNode') });
        return;
      }

      if (node.hasChildren) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.preDelChildNode') });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.preDelChildNode') });
        return;
      }
      const logParam = {
        module: this.logParamInfo.module, // 组织架构
        execFunName: this.logParamInfo.execFunName[3], // 修改节点
        exectype: 3,
        execData: [{ vpnid: node.id.split('_')[2] }],
      };
      await this.$axios
        .post('/lte/ems/subscriber/mcs/requestCommonMicro', {
          vo: { productType:1,enterpriseDomain:"mcs.com",opCount:1,vpnId: [node.id.split('_')[2]],flag:0 },
          info: { msgid: 46102, neid: this.nodeSelect.id.split('_')[0] },
          log: logParam
        })
        .then(response => {
/*          if (response.status !== 200) {
            // this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
            EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
            return;
          }
          if (response.data.resultVal && response.data.resultVal.length > 0) {
            EventBus.$emit('toast', { type: 'success', content: response.data.resultVal[0].display});
            //this.$layer.alert({ msg: response.data.resultVal[0].display });
            if (response.data.resultVal[0].code.split('.')[2] === '0') {
              this.getOrganizationalTree();
            }
          } else {
            // this.$layer.alert({ msg: this.$t('resultReturnFailedTip') });
            EventBus.$emit('toast', { type: 'warning', content: this.$t('resultReturnFailedTip') });
          }*/
            this.commonResp(response);
            this.getOrganizationalTree();
        });
      this.nodeSelect=null;
    },
    // 校验下发数据，将0转为null
    validateVPN(vpnNode) {
      vpnNode.vpnClass1 = vpnNode.vpnClass1 === 0 ? null : vpnNode.vpnClass1;
      vpnNode.vpnClass2 = vpnNode.vpnClass2 === 0 ? null : vpnNode.vpnClass2;
      vpnNode.vpnClass3 = vpnNode.vpnClass3 === 0 ? null : vpnNode.vpnClass3;
      vpnNode.vpnClass4 = vpnNode.vpnClass4 === 0 ? null : vpnNode.vpnClass4;
      vpnNode.vpnClass5 = vpnNode.vpnClass5 === 0 ? null : vpnNode.vpnClass5;
      vpnNode.vpnClass6 = vpnNode.vpnClass6 === 0 ? null : vpnNode.vpnClass6;
      return vpnNode;
    },
    filterTreeDataOfChildren(data, children = []) {
      if (children !== undefined || children !== null) {
        this.containsKeywords(children, this.keywords);
      }
    },
    filterLocalTreeData() {
      console.log(this.keywords);
      console.log(this.staDoFieldsList);
      if (this.keywords.trim() === '') {
        const vpn = this.staDoFieldsList.filter((item) => item.id_show === `${this.neid}_7_0`);
        this.fields = new TreeDatas(vpn);//渲染组织架构树
        this.timer1 = setTimeout(() => {
          this.$refs.tree1.disableNodes(this.disableNode);
        }, 100);
        this.setfFuzzyFlag(false);
        return null;
      } else {
        this.setfFuzzyFlag(true);
      }
      const vpn = this.staDoFieldsList.filter((item) => item.id_show === `${this.neid}_7_0`);
      this.staDoFields = JSON.parse(JSON.stringify(vpn));
      const tempFields = this.containsKeywordsFun(this.staDoFields, this.keywords);
      console.log('tempFields', tempFields);
      this.fields = new TreeDatas(tempFields);//渲染组织架构树
      this.timer1 = setTimeout(() => {
        this.$refs.tree1.disableNodes(this.disableNode);
      }, 100);
    },
    containsKeywordsFun(array, keywords) {
      const queryResult = [];// 重新绘制树形结构即children
      for (let i = 0; i < array.length; i++) {
        const cp = array[i];
        const { checked, code, iconCls, id_show, name, text, vpnNodeString } = array[i];
        const temp = { checked, code, iconCls, id_show, name, text, vpnNodeString, children: [] };
        if (cp.children != null && cp.children.length !== 0) {
          const tempMap = new Map();
          tempMap.set(temp.id_show, temp);
          this.childIraContainsKeywords(cp.children, keywords, temp, tempMap);
          console.log(temp);
          const aaa = Array.from(tempMap);
          console.log(aaa.length);
          for (let ii = aaa.length - 1; ii >= 0; ii--) {
            const tt = aaa[ii];
            console.log(tt[0], tt[1].children);
            if (tt[1].children.length !== 0) {
              if (tempMap.get(tt[1].parentId) !== undefined) { // .includes(keywords)
                const pChild = tempMap.get(tt[1].parentId).children.filter((item) => item.id_show === tt[0]);
                if (pChild && pChild.length === 0) {
                  tempMap.get(tt[1].parentId).children.splice(0, 0, tt[1]);
                }
              }
            }
          }
          if (temp.children && temp.children.length > 0) {
            // 把节点添加到树中
            queryResult.push(temp);
          } else {
            if (cp.name.includes(keywords)) {
              queryResult.push(temp);
            }
          }
        } else {
          if (cp.name.includes(keywords)) {
            queryResult.push(temp);
          }
        }
      }
      return queryResult;
      // return result;
    },
    childIraContainsKeywords(cpArray, keywords, parentRoot, tempMap = new Map()) {
      console.log('parentRoot.id_show parentRoot.parentId', parentRoot.id_show, parentRoot.parentId);
      cpArray.forEach((item) => {
        const cp = item;
        const { checked, code, iconCls, id_show, name, text, vpnNodeString } = item;
        const temp = { checked, code, iconCls, id_show, name, text, vpnNodeString, children: [], parentId: parentRoot.id_show };
        if (cp.name.includes(keywords)) {
          parentRoot.children.push(temp);
          if (cp.children != null && cp.children.length !== 0 && tempMap.get(temp.id_show) === undefined) {
            tempMap.set(temp.id_show, temp);
          }
        }

        if (cp.children != null && cp.children.length !== 0) {
          if (!cp.name.includes(keywords)) {
            tempMap.set(temp.id_show, temp);
          }
          this.childIraContainsKeywords(cp.children, keywords, temp, tempMap);
        }
      });
    },
    childContainsKeywordsBak(cp, keywords, level) {
      const tempResult = cp.children.filter(item => item.name.includes(keywords));
      const tempNoResult = cp.children.filter(item => !item.name.includes(keywords));
      if (tempResult.length !== 0) {
        root.children.push(tempResult);
      }
      if (tempNoResult.length !== 0) {
        level++;
        for (let i = 0; i < cp.children.length; i++) {
          const item = cp.children[i];
          if (item.children !== undefined && item.children !== null && item.children.length !== 0) {
            this.childContainsKeywords(item, keywords, item);
          }
        }
      }
    },
    containsKeywords(data, keywords) {
      return data.name.includes(keywords);
    },
    // contaimsKeywords
    refreshLocalTreeData() {

    },
    setFieldsDataFilter() {

    },
    // treeTemplate(e) {
    //   return {
    //     template: treeTemplateOrder
    //   };
    // },
    /**
     * 数组去重函数
     * @param array
     * @returns {Array}
     */
    arrayDistinct(array) {
      const res = [];
      const json = {};
      try {
        for (let i = 0; i < array.length; i++) {
          if (!json[array[i]]) {
            res.push(array[i]);
            json[array[i]] = 1;
          }
        }
      } catch (err) {
        console.log(err.message);
      }
      return res;
    },
    // 页面节点样式初始化
    setFontCss(treeNode) {
      let view = { color: '#f0f0f5', 'font-weight': 'bold' };
      if (treeNode.role) view = { color: '#000000', 'font-weight': 'normal' };
      return view;
    },
    nodeDraggingMethod(args) {
      // dropnode为空---加上多个网元的判断
      // 父id不相同，不让移动
      // 父id相同,不允许移入同级节点中
      if (args.droppedNode === null || (args.draggedNode !== null && args.draggedNode.classList[1].split('-')[2] === '1') || (args.droppedNodeData !== null && (args.draggedNodeData.parentID !== args.droppedNodeData.parentID
        || (args.draggedNodeData.parentID === args.droppedNodeData.parentID && args.draggedNode.classList[1].split('-')[0] === args.droppedNode.classList[1].split('-')[0]
          && args.draggedNode.classList[1].split('-')[2] === args.droppedNode.classList[1].split('-')[2] && args.dropLevel.toString() !== args.droppedNode.classList[1].split('-')[2])))) {
        args.dropIndicator = 'e-no-drop';
      }
    },
    nodeDragStopMethod(args) {
      if (args.droppedNode === null || (args.draggedNode !== null && args.draggedNode.classList[1].split('-')[2] === '1') || (args.droppedNodeData !== null && (args.draggedNodeData.parentID !== args.droppedNodeData.parentID
        || (args.draggedNodeData.parentID === args.droppedNodeData.parentID && args.draggedNode.classList[1].split('-')[0] === args.droppedNode.classList[1].split('-')[0]
          && args.draggedNode.classList[1].split('-')[2] === args.droppedNode.classList[1].split('-')[2] && args.dropLevel.toString() !== args.droppedNode.classList[1].split('-')[2])))) {
        args.cancel = true;
      } else {
        // 根据此parentid，找到所以子节点，按li排序---this.initData中设置根据parentid
        console.log(args.draggedParentNode.children[2].children.length, args.droppedNodeData);
        const array = args.draggedParentNode.children[2].children;
        for (const item of array) {
          item.setAttribute('sortable', true);
        }
        console.log('=======', args.draggedNodeData.parentID, args.droppedNodeData, args.draggedNodeData);
      }
    },
  },
  // mounted() {
  //   this.getOrganizationalTree();
  // }
};
</script>
